import React, { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import '../../custom.css';

export default function PRHError({ error = null }) {
    return (
        <div className="error"> {error} </div>
    );
}


